// @flow
import React, {type Node} from 'react';
import classNames from 'classnames';

import s from './plus.scss';

type PropsType = {
    isActive: boolean,
    isClearance: boolean,
};

export const PlusIcon = ({isActive, isClearance}: PropsType): Node => (
    <div
        className={classNames(s.wrap, {[s.active]: isActive}, {[s.red]: isClearance && isActive})}
    />
);
